<template>
    <span v-show="show">
        <slot></slot>
    </span>
</template>
<script>
import { EventBus } from '../event-bus.js';
export default {
    props: {
        initialValues: {
            type: Object,
            required: true
        },
        requiredValues: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            show: false,
            values: this.initialValues,
        }
    },
    methods: {
        checkVisibility() {
            return Object.keys(this.requiredValues).every(key => {
                return this.values[key] == this.requiredValues[key]
            });
        }
    },
    created() {
        this.show = this.checkVisibility();
    },
    mounted() {
        EventBus.$on('form:element:changed', (name, value) => {
            if (Object.keys(this.requiredValues).indexOf(name) === -1) {
                return;
            }

            this.values[name] = value;
            this.show = this.checkVisibility();
        });
    }
}
</script>